// refresh CSRF tokens
function showColumnSortSpinner(column) {
  var th = document.querySelector('th.col-' + column);
  if (!th) return;
  var indicator = th.querySelector(".ajax-indicator");
  if (indicator) indicator.style.display = 'inline-block';
  var sortIcon = th.querySelector(".sort-icon");
  if (sortIcon) sortIcon.style.display = 'none';
}

var refreshCSRFTokens = function() {
  console.log("refreshCSRF");
  window.__csrfRefreshCount = (window.__csrfRefreshCount || 0) + 1;
  window.__lastCsrfRefreshAt = new Date().toISOString();

  const metaTag = document.querySelector('meta[name="csrf-token"]');
  const metaTokenPresent = !!(metaTag && metaTag.getAttribute('content'));
  let formsUpdatedCount = 0;

  if (!metaTokenPresent) {
    window.__csrfLastRefresh = { formsUpdatedCount: 0, metaTokenPresent: false };
    recordCsrfClientMetadata("csrf refresh", window.__csrfLastRefresh);
    return;
  }

  const token = metaTag.getAttribute('content');
  document.querySelectorAll('form input[name="authenticity_token"]').forEach((el) => {
    el.value = token;
    formsUpdatedCount += 1;
  });

  window.__csrfLastRefresh = { formsUpdatedCount, metaTokenPresent };
  recordCsrfClientMetadata("csrf refresh", window.__csrfLastRefresh);
}

window.refreshCSRFTokens = refreshCSRFTokens;

function recordCsrfClientMetadata(name, metadata) {
  if (!window.Bugsnag) return;

  try {
    if (typeof window.Bugsnag.leaveBreadcrumb === "function") {
      window.Bugsnag.leaveBreadcrumb(name, metadata, "state");
    }
    if (typeof window.Bugsnag.addMetadata === "function") {
      window.Bugsnag.addMetadata("csrf", metadata);
    }
  } catch (e) {
    // Diagnostics should never block the user action being diagnosed.
  }
}

function captureCsrfSubmitDiagnostics(event) {
  const form = event && event.target && event.target.closest ? event.target.closest("form") : null;
  if (!form) return;

  const metaTag = document.querySelector('meta[name="csrf-token"]');
  const submitter = event.submitter;
  const metaToken = metaTag && metaTag.getAttribute("content");
  const hiddenTokens = form.querySelectorAll('input[name="authenticity_token"]');
  const firstHiddenToken = hiddenTokens[0];
  const metadata = {
    action: safeFormActionPath(form),
    method: (form.method || "get").toUpperCase(),
    provider: form.dataset.provider || (submitter && submitter.dataset ? submitter.dataset.provider : undefined),
    hasMetaToken: !!metaToken,
    preRefreshHiddenTokenCount: hiddenTokens.length,
    preRefreshHiddenTokenPresent: !!(firstHiddenToken && firstHiddenToken.value),
    preRefreshHiddenTokenMatchesMeta: !!(metaToken && firstHiddenToken && firstHiddenToken.value === metaToken),
    submitterType: submitter ? submitter.type : undefined,
    refreshCount: window.__csrfRefreshCount || 0
  };

  window.__csrfLastSubmit = metadata;
  recordCsrfClientMetadata("csrf submit", metadata);
}

window.captureCsrfSubmitDiagnostics = captureCsrfSubmitDiagnostics;

function safeFormActionPath(form) {
  try {
    return new URL(form.action, window.location.href).pathname;
  } catch (e) {
    return "";
  }
}

// Action-cached pages bake a stale authenticity_token into form HTML. Refresh
// every form's token from the (always-fresh) layout meta tag right before any
// submit. Capture phase so this runs before the browser serializes the form.
// Replaces the global $(document).ajaxComplete(refreshCSRFTokens) handler that
// was removed in the jQuery migration (commit 87b18dbb7).
document.addEventListener('submit', function(event) {
  captureCsrfSubmitDiagnostics(event);
  refreshCSRFTokens();
}, true);

var MOBILE_NAV_SCROLL_SELECTOR = "[data-mobile-scroll-nav]";
var MOBILE_NAV_DESKTOP_QUERY = "(min-width: 1200px)";
var MOBILE_NAV_HIDE_THRESHOLD = 122;
var MOBILE_NAV_SCROLL_DELTA = 5;

function initMobileNavScroll(options) {
  options = options || {};

  var nav = options.nav || document.querySelector(options.selector || MOBILE_NAV_SCROLL_SELECTOR);
  if (!nav) return null;

  var collapseSelector = options.collapseSelector || "#navbarSupportedContent";
  var desktopQuery = options.desktopQuery || MOBILE_NAV_DESKTOP_QUERY;
  var hideThreshold = options.hideThreshold || MOBILE_NAV_HIDE_THRESHOLD;
  var scrollDelta = options.scrollDelta || MOBILE_NAV_SCROLL_DELTA;
  var mediaQuery = options.mediaQuery || (window.matchMedia ? window.matchMedia(desktopQuery) : null);

  function currentScrollY() {
    return Math.max(window.pageYOffset || window.scrollY || 0, 0);
  }

  function clearNavState() {
    nav.classList.remove("nav-fixed");
    nav.classList.remove("nav-hidden");
  }

  function showFixedNav() {
    nav.classList.add("nav-fixed");
    nav.classList.remove("nav-hidden");
  }

  function hideFixedNav() {
    nav.classList.add("nav-fixed");
    nav.classList.add("nav-hidden");
  }

  function dropdownOpen(toggle) {
    var menu = toggle.parentElement ? toggle.parentElement.querySelector(".dropdown-menu") : null;
    return toggle.classList.contains("show") || toggle.getAttribute("aria-expanded") === "true" || (menu && menu.classList.contains("show"));
  }

  function closeBootstrapDropdownToggle(toggle) {
    if (!dropdownOpen(toggle)) return false;

    var menu = toggle.parentElement ? toggle.parentElement.querySelector(".dropdown-menu") : null;
    var dropdownController = window.bootstrap && window.bootstrap.Dropdown && window.bootstrap.Dropdown.getInstance(toggle);
    if (dropdownController && typeof dropdownController.hide === "function") {
      dropdownController.hide();
      return true;
    }

    toggle.classList.remove("show");
    toggle.setAttribute("aria-expanded", "false");
    if (menu) menu.classList.remove("show");
    return true;
  }

  function topLevelNavDropdownToggle(toggle) {
    var item = toggle && toggle.parentElement;
    return !!(
      item &&
      item.classList.contains("nav-item") &&
      item.classList.contains("dropdown") &&
      item.parentElement &&
      item.parentElement.classList.contains("navbar-nav") &&
      nav.contains(item)
    );
  }

  function closeSiblingTopLevelDropdowns(activeToggle) {
    var closed = false;

    nav.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function(toggle) {
      if (toggle === activeToggle || !topLevelNavDropdownToggle(toggle)) return;
      closed = closeBootstrapDropdownToggle(toggle) || closed;
    });

    return closed;
  }

  function closeBootstrapCollapse() {
    var collapse = options.collapse || document.querySelector(collapseSelector);
    if (!collapse || !collapse.classList.contains("show")) return false;
    var toggles = collapse.id ? nav.querySelectorAll('[aria-controls="' + collapse.id + '"]') : [];

    var collapseController = window.bootstrap && window.bootstrap.Collapse && window.bootstrap.Collapse.getInstance(collapse);
    if (collapseController && typeof collapseController.hide === "function") {
      collapseController.hide();
    } else {
      collapse.classList.remove("show");
      toggles.forEach(function(toggle) {
        toggle.setAttribute("aria-expanded", "false");
        toggle.classList.add("collapsed");
      });
    }

    toggles.forEach(function(toggle) {
      if (document.activeElement === toggle && typeof toggle.blur === "function") toggle.blur();
    });

    return true;
  }

  function closeBootstrapDropdowns() {
    var closed = false;

    nav.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function(toggle) {
      closed = closeBootstrapDropdownToggle(toggle) || closed;
    });

    return closed;
  }

  function closeNavbarAutocomplete(options) {
    options = options || {};
    var blur = options.blur !== false;
    var closed = false;

    nav.querySelectorAll("input, textarea, select").forEach(function(input) {
      var tomSelect = input.tomselect;
      if (!tomSelect) return;

      var open = tomSelect.isOpen || (tomSelect.dropdown && tomSelect.dropdown.classList.contains("active"));
      var focused = document.activeElement === input || (tomSelect.control && tomSelect.control.contains(document.activeElement));
      if (!open && (!blur || !focused)) return;

      if (typeof tomSelect.close === "function") tomSelect.close();
      if (blur && typeof tomSelect.blur === "function") tomSelect.blur();
      closed = true;
    });

    return closed;
  }

  function closeOpenNavOverlays(options) {
    var closed = false;
    closed = closeNavbarAutocomplete(options) || closed;
    closed = closeBootstrapDropdowns() || closed;
    closed = closeBootstrapCollapse() || closed;
    return closed;
  }

  function eventInsideOpenNavSurface(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== "function") return false;
    return !!(target.closest(MOBILE_NAV_SCROLL_SELECTOR) || target.closest(".navbar-search-dropdown"));
  }

  function desktopNav() {
    return !!(mediaQuery && mediaQuery.matches);
  }

  var previousScrollY = currentScrollY();

  function handleScroll() {
    var scrollY = currentScrollY();

    if (scrollY === 0) {
      clearNavState();
      previousScrollY = scrollY;
      return;
    }

    if (!desktopNav()) closeOpenNavOverlays({ blur: false });

    var delta = scrollY - previousScrollY;
    if (Math.abs(delta) < scrollDelta) return;

    if (delta < 0) {
      showFixedNav();
    } else if (scrollY > hideThreshold) {
      hideFixedNav();
    }

    previousScrollY = scrollY;
  }

  function handleDocumentPointerDown(event) {
    if (desktopNav()) return;
    if (eventInsideOpenNavSurface(event)) return;
    if (closeOpenNavOverlays()) handleScroll();
  }

  function handleNavDropdownShow(event) {
    var toggle = event && event.target;
    if (!topLevelNavDropdownToggle(toggle)) return;
    closeSiblingTopLevelDropdowns(toggle);
  }

  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", handleScroll);
  document.addEventListener("pointerdown", handleDocumentPointerDown, true);
  nav.addEventListener("show.bs.dropdown", handleNavDropdownShow);
  handleScroll();

  return {
    handleScroll: handleScroll,
    destroy: function() {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      document.removeEventListener("pointerdown", handleDocumentPointerDown, true);
      nav.removeEventListener("show.bs.dropdown", handleNavDropdownShow);
      clearNavState();
    }
  };
}

document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var dfcBtn = e.target.closest('.btn-toggle-dfc');
    if (dfcBtn) {
      var card = e.target.closest(".price-card-dfc");
      if (!card) return;
      var toggleEl = e.target.closest("[data-bs-toggle=button]");
      if (toggleEl && toggleEl.classList.contains("active")) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    }
  });

  var jwtBtn = document.querySelector(".btn-show-jwt");
  if (jwtBtn) {
    jwtBtn.addEventListener('click', function() {
      var jwt = document.getElementById("jwt");
      if (jwt) jwt.type = "text";
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.btn-copy-to-clipboard')) return;
    var scope = e.target.closest(".copy-to-clipboard-scope");
    if (!scope) return;
    var target = scope.querySelector(e.target.dataset.target);
    if (!target) return;
    if (target.type === "password") {
      target.type = "text";
    }
    target.select();
    document.execCommand("copy");
    if (e.target.dataset.messageContainer) {
      var messageContainer = scope.querySelector(e.target.dataset.messageContainer);
      if (messageContainer) {
        messageContainer.innerHTML = "<div class='alert alert-info'>" + e.target.dataset.message + "</div>";
      }
    }
  });

  var authForm = document.querySelector(".layout-auth-identity-form");
  if (authForm) {
    authForm.addEventListener('submit', function() {
      var emailField = authForm.querySelector('.layout-auth-identity-form-email');
      if (emailField) emailField.value = emailField.value.toLowerCase();
    });
  }

  var sidebarClose = document.getElementById("layout-scoops-sidebar-pop-close");
  if (sidebarClose) {
    sidebarClose.addEventListener('click', function() {
      Cookies.set('layout-sidebar-pop-disable', 'true', { expires: 3650, path: '/' });
      var sidebar = document.getElementById('layout-scoops-sidebar-pop');
      if (sidebar) sidebar.style.display = 'none';
    });
  }

  var popDisable = Cookies.get('layout-sidebar-pop-disable');
  if (popDisable === undefined) {
    var sidebarPop = document.getElementById("layout-scoops-sidebar-pop");
    if (sidebarPop) sidebarPop.classList.remove("hidden");
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.search-trigger')) return;
    e.preventDefault();
    document.querySelectorAll('.cd-morph-dropdown').forEach(function(el) {
      el.classList.remove("nav-open");
    });
    var searchForm = document.querySelector('.layout-search-form');
    if (searchForm) searchForm.classList.toggle('active');
    var searchInput = document.querySelector('.layout-search-input-field');
    if (searchInput) searchInput.focus();
  });

  document.querySelectorAll("#layout-show-submenu").forEach(function(el) {
    var target = "#layout-submenu-" + el.dataset.target;
    var submenu = document.querySelector(target);
    if (submenu) submenu.classList.add("show");
    var mainContent = document.querySelector(".cd-main-content");
    if (mainContent) mainContent.classList.add("cd-main-content-with-submenu");
  });

  initMobileNavScroll();

});


function popout(url) {
  window.open(url, "_blank", "toolbar=no,menubar=no,status=no,resizeable=no,location=no");
}

if (typeof module !== "undefined") {
  module.exports = {
    initMobileNavScroll
  };
}
